<template>
  <div>
    <b-row>
      <b-col lg="4">
        <vs-card>
          <div slot="header">
            <h3>Tanım Ekle</h3>
          </div>
          <div>
            <b-row>
              <b-col lg="12">
                <v-select v-model="tanimSelect" :options="tanimlist" placeholder="Tanım Seç" label="name" style=""
                  @input="secilenTanim($event)">
                </v-select>
              </b-col>
            </b-row>
          </div>
        </vs-card>
      </b-col>
      <b-col lg="8" style="background: white; margin-bottom: 20px">
        <div slot="header">
          <h3 v-if="tanimSelect == 'Haber'">Haber Ekle</h3>
          <h3 v-if="tanimSelect == 'Duyuru'">Duyuru Ekle</h3>
          <h3 v-if="tanimSelect == 'Banner'">Banner Ekle</h3>
        </div>
        <div>
          <b-row>
            <b-col lg="4" v-if="tanimSelect == 'Banner'" style="text-align: center"><input type="file" accept="image/*"
                @change="onFileChange" id="file-input" />
            </b-col>
            <b-col lg="8" v-if="tanimSelect == 'Banner'">
              <b-row>
                <b-col>
                  <b-img style="width: 250px" thumbnail fluid :src="imageBase64" />

                </b-col>
                <b-col>
                  <vs-textarea label="Url giriniz" v-model="urltext" />

                </b-col>
              </b-row>
            </b-col>

            <b-col lg="12" v-if="tanimSelect == 'Haber'">
              <vs-textarea label="Haber giriniz" v-model="habertext" />
            </b-col>
            <b-col lg="12" v-if="tanimSelect == 'Duyuru'">
              <vs-textarea label="Duyuru giriniz" v-model="duyurutext" />
            </b-col>
          </b-row>
        </div>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button @click="tanimKaydet()" type="gradient" size="small" icon="done">
              <span style="font-size: 11px" v-if="tanimSelect == 'Banner'">Banner Ekle</span>
              <span style="font-size: 11px" v-if="tanimSelect == 'Haber'">Haber Ekle</span>
              <span style="font-size: 11px" v-if="tanimSelect == 'Duyuru'">Duyuru Ekle</span>
            </vs-button>
          </vs-row>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <vx-card>
        <vue-good-table :columns="columns" :rows="tanimlarListesi" :rtl="dir">
          <template slot="table-row" slot-scope="props">
            <!-- Column: Name -->
            <div v-if="props.column.field === 'base'" class="text-nowrap">
              <img style="width: 150px" square :src="props.row.base" class="mx-1" />
            </div>

            <!-- Column: Status -->
            <span v-else-if="props.column.field === 'DURUM'">
              <b-row>
                <b-col>
                  <vs-button style="padding: 0" @click="stockDetail(props.row)" color="white" type="filled"
                    size="small"><vs-chip style="width: 50px" transparent :color="statusVariant(props.row.DURUM)">
                      {{ props.row.DURUM }}
                    </vs-chip></vs-button>
                </b-col>
              </b-row>
            </span>

            <!-- Column: Action -->
          </template>
        </vue-good-table>
      </vx-card>

      <vs-prompt title="Durum Güncelle" acceptText="Güncelle" cancelText="Vazgeç" @accept="durumGuncelle"
        :active.sync="activePrompt">
        <div class="con-exemple-prompt">
          <b-row style="margin-top: 20px">
            <div class="centerx">
              <v-select v-model="islemselected" id="selected" placeholder="İşlem" label="title" :options="islemOptions" />
            </div>
          </b-row>
        </div>
      </vs-prompt>
    </b-row>
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import vSelect from "vue-select";
import { BBadge } from "bootstrap-vue";
import { BButton, VBPopover, BPopover } from "bootstrap-vue";
import { BImg, BContainer, BRow, BCol } from "bootstrap-vue";
import { uuid } from "vue-uuid";
export default {
  components: {
    "v-select": vSelect,
    BBadge,
    BButton,
    BPopover,
    BImg,
    BContainer,
    BRow,
    BCol
  },
  directives: {
    "b-popover": VBPopover
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    }
  },
  data() {
    return {
      urltext:"",
      fFile: "",
      guidid: uuid.v4(),
      uuid: uuid.v1(),
      id: null,
      islemselected: "",
      islemOptions: ["Aktif", "Pasif"],
      activePrompt: false,

      switch1: true,

      activeTooltip1: false,
      pictureState: false,

      primary: "primary",
      habertext: "",
      duyurutext: "",
      tanimSelect: "",
      imageBase64: "",
      imageName: "",
      tanimlist: ["Banner", "Haber", "Duyuru"],
      tanimlarListesi: [],
      secilen: [],

      columns: [
        {
          label: "TÜR",
          field: "TUR"
        },
        {
          label: "AÇIKLAMA",
          field: "ACIKLAMA"
        },
        {
          label: "RESİM ADI",
          field: "RESIMADI"
        },
        {
          label: "DURUM",
          field: "DURUM"
        }
      ],
      dir: false
    };
  },
  methods: {
    secilenTanim() {
      this.imageBase64 = "";
      this.habertext = "";
      this.duyurutext = "";
    },
    newCyclists() {
      const id = this.id;
      const newID = this.uuid.v4();
      return {
        ...cyclists,
        id: newID
      };
    },
    durumGuncelle() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      var args = {};
      if (vm.islemselected == "Pasif") {
        args = {
          token: Store.state.tokenId,
          ID: vm.secilen.ID,
          DURUM: "Pasif",

          TUR: vm.secilen.TUR,
          ACIKLAMA: vm.secilen.ACIKLAMA,
          RESIMADI: vm.secilen.RESIMADI
        };
      } else if (vm.islemselected == "Aktif") {
        args = {
          token: Store.state.tokenId,
          ID: vm.secilen.ID,
          DURUM: "Aktif",

          TUR: vm.secilen.TUR,
          ACIKLAMA: vm.secilen.ACIKLAMA,
          RESIMADI: vm.secilen.RESIMADI
        };
      }

      soap.createClient(url, function (err, client) {
        client.B2B_PanelIslem(args, function (err, result) {
          vm.tanimlarList();
        });
      });
    },
    stockDetail(id) {
      this.secilen = id;
      this.activePrompt = true;
    },

    statusVariant(status) {
      if (status == "Aktif") {
        //  this.pictureState = true;
        return "success";
      } else if (status == "Pasif") {
        //this.pictureState = false;
        return "danger";
      }
    },
    tanimKaydet() {
      var vm = this;
      const vs = this.$vs;
      if (vm.imageBase64 == "" && vm.habertext == "" && vm.duyurutext == "") {
        vs.notify({
          text: "Lütfen alanları doldurunuz",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center"
        });
      } else {
        const soap = require("soap");
        let url = state.sistemAddress;
        var args = {};
        if (vm.tanimSelect == "Banner") {
          args = {
            token: Store.state.tokenId,
            ID: "",
            TUR: "Banner",
            ACIKLAMA: vm.urltext,
            RESIMADI: vm.imageName,
            DURUM: "Aktif"
          };
          soap.createClient(url, function (err, client) {
            client.B2B_PanelIslem(args, function (err, result) {
              try {
                vm.tanimlarList();

                vs.notify({
                  text: "Banner eklendi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } catch (error) {
                vs.notify({
                  text: "Banner eklenirken bir hata oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
            });
          });
          vm.resimEkle();
        } else if (vm.tanimSelect == "Haber") {
          args = {
            token: Store.state.tokenId,
            ID: "",
            TUR: "Haber",
            ACIKLAMA: vm.habertext.replace("'", ""),
            RESIMADI: "",
            DURUM: "Pasif"
          };

          soap.createClient(url, function (err, client) {
            client.B2B_PanelIslem(args, function (err, result) {
              try {
                vm.tanimlarList();

                vs.notify({
                  text: "Haber eklendi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } catch (error) {
                vs.notify({
                  text: "Haber eklenirken bir hata oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
            });
          });
        } else if (vm.tanimSelect == "Duyuru") {
          args = {
            token: Store.state.tokenId,
            ID: "",
            TUR: "Duyuru",
            ACIKLAMA: vm.duyurutext.replace("'", ""),
            RESIMADI: "",
            DURUM: "Aktif"
          };

          soap.createClient(url, function (err, client) {
            client.B2B_PanelIslem(args, function (err, result) {
              try {
                vm.tanimlarList();

                vs.notify({
                  text: "Duyuru eklendi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center"
                });
              } catch (error) {
                vs.notify({
                  text: "Duyuru eklenirken bir hata oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center"
                });
              }
            });
          });
        }
      }
    },
    resimEkle() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;

      const args = {
        stokKodu: this.guidid,
        barkod: ""
      };
      soap.createClient(url, function (err, client) {
        client.B2B_klasorResimleri(args, function (err, result) {
          vm.tanimlarList();
        });
      });
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = e => {
        vm.image = e.target.result;
        vm.imageBase64 = e.target.result;
        vm.imageName = file.name;

        vm.upload(e.target.result, file.name);
      };
      reader.readAsDataURL(file);
    },
    upload(f, fileName) {
      this.guidid = uuid.v4();
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;
      url = url.replace("sistem", "upload");

      const args = {
        f: f,
        stokKodu: this.guidid,
        barkod: "",
        fileName: fileName
      };
 
      soap.createClient(url, function (err, client) {
        client.B2B_uploadFileProduct(args, function (err, result) {
 
          if (result.B2B_uploadFileProductResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
        });
      });
    },
    tanimlarList() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        TUR: "",
        DURUM: ""
      };
      soap.createClient(url, function (err, client) {
        client.B2B_LS_PanelIslem(args, function (err, result) {
          vm.veriler = JSON.parse(result.B2B_LS_PanelIslemResult);
          vm.tanimlarListesi = vm.veriler;
          /* if (result.B2B_LS_PanelIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }*/
        });
      });
    }
  },
  created() {
    this.tanimlarList();
  }
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}

.vuesax-app-is-ltr .vs-chip--text {
  font-size: 14px;
}

.aktif {
  color: #28c76f !important;
  background-color: #68d79a;
}

.dropbox {
  outline: 2px dashed grey;
  /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0;
  /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue;
  /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

table.vgt-table {
  font-size: small;
}

.con-vs-dialog .vs-dialog {
  max-width: 500px;
}

.view-upload {
  z-index: 52000000000000000000000000000000000000000000000000000000;
}

.con-input-upload {
  width: 100px;
  height: 100px;
}

.con-img-upload .img-upload {
  width: 100px;
  height: 100px;
}
</style>
